// extracted by mini-css-extract-plugin
export default {"border-container":"1px solid rgb(221, 224, 230)","hrule":"styles_hrule__+xVTn","sm":"styles_sm__tKgnz","md":"styles_md__jfp0a","lg":"styles_lg__KflXz"};